import './aboutMe.css'; // Assuming you have a CSS file for styling
import { DiCode } from "react-icons/di";
import { FaUniversity } from "react-icons/fa";
import { SiStackhawk } from "react-icons/si";
export default function AboutMe(){
  return (
    <div className='about service' id='project'>
     <h2 className="titels">About Me </h2>   
    <div className="container">
      <div className="card">
        <div className="face face1">
          <div className="content">
            <span className='span_serves'>
          <DiCode />

            </span>
            <h3>Full Stack</h3>
          </div>
        </div>
        <div className="face face2">
          <div className="content">
            <p>I took a web development course on Devrabic. It was a great experience that improved my skills.</p>
            <a href="https://devrabic.com/en">Read More</a>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="face face1">
          <div className="content">
          <span className='span_serves'>

          <FaUniversity />
            </span>
             <h3>AABU</h3>
          </div>
        </div>
        <div className="face face2">
          <div className="content">
            <p>I am a student at Al al-Bayt University, studying computer science.</p>
            <a href="https://www.aabu.edu.jo/AR/Pages/default.aspx">Read More</a>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="face face1">
          <div className="content">
          <span className='span_serves'>
            <SiStackhawk/>
          </span>
            <h3>MERN Stack</h3>
          </div>
        </div>
        <div className="face face2">
          <div className="content">
            <p>I learned MERN Stack technology, which greatly improved my skills and expanded my web development horizons</p>
            <a className='content_a' href="https://www.udemy.com/course/yehiatech-react-nodejs-express-mongodb-in-arabic/?fbclid=PAZXh0bgNhZW0CMTEAAaY4mBpC3KszFfq3Tqpd7hDBLYyXBbVwUW0oC3vOVEWpOWjPCcm02bWxn18_aem_kz22jsNjMXNMJMsHDBxakw">Read More</a>
          </div>
        </div>
      </div>
    </div>

    </div>
  );
};

